import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import PrincipalComponent from './components/PrincipalComponent'
import ContactoComponent from './components/ContactoComponent'
import DashboardComponent from './components/DashboardComponent'
import PerfilComponent from './components/subpaginas/PerfilComponent'
import OfertaDispComponent from './components/subpaginas/OfertaDispComponent'
import AdminInstanciasComponent from './components/subpaginas/AdminInstanciasComponent'
import AdminOfertaFomComponent from './components/subpaginas/AdminOfertasFormComponent'
import AdminGruposComponent from './components/subpaginas/AdminGruposComponent'
import MiFormacionComponent from './components/subpaginas/MiFormacionComponent'
import AdminCargaMasivaComponent from './components/subpaginas/AdminCargaMasivaComponent'
import AdminUsuariosComponent from './components/subpaginas/AdminUsuariosComponent'
import AdminRegistrosComponent from './components/subpaginas/AdminRegistrosComponent'
import AdminReportesComponent from './components/subpaginas/AdminReportesComponent'
import ValidacionQR from './components/ValidacionQR.vue'
import RegistroComponent from './components/RegistroComponent'
//import { queryIEASIS } from "./backIeasis/dbContextConexion";

const href = location.href;
//console.log('entro con ruta', href, 'email', localStorage.getItem('email'))
if (!localStorage.getItem('email')) {
    if (href.includes('login')) {
        const url2 = 'https://ieasis.iea.edu.mx/wsnomsis/Profile?valor=entrar&sys=ieasis'
        window.location.href = url2;
    }
    if (href.includes('valores')) {

        if (localStorage.getItem('email')) {
            console.log('this.gcuenta en IF: ', sessionStorage.getItem('email'));
            console.log(localStorage.getItem('email'));
        }
        else {
            const galleta2 = href;
            if (galleta2 && galleta2.includes(';')) {
                const cookies = galleta2.split(';');

                for (let i = 0; i < cookies.length; i++) {
                    const galleta = decodeURI(cookies[i]);
                    console.log(i, galleta);
                    if (galleta.trim().substring(0, 7) === 'profile') {
                        const cookie2 = galleta.split('|');
                        console.log(cookie2);
                        //gCuenta = cookie2[1];
                        sessionStorage.setItem('email', cookie2[1]);
                        localStorage.setItem('email', cookie2[1]);

                        

                        window.location.href = '/'
                        //location.reload();
                    }
                    if (galleta.trim().substring(0, 5) === 'token') {
                        const data = galleta.split('|');
                        sessionStorage.setItem('accessToken', data[1]);
                        console.log(data);
                        const token = data[1];
                        console.log('TOKEN: ', token);
                    }
                }

            }

        }
    }
}





Vue.prototype.$usuario = (usuario) => {
    console.log('Antes usuario', usuario);
    this.usuario = usuario
    //this.usuario = 'OIMR680714MDFLDQ06'
    this.usuario = sessionStorage.getItem('usuario');
    console.log('Despues usuario', usuario);

};



window.$ = window.jQuery = require('jquery');

Vue.config.productionTip = false

Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'home',
    component: PrincipalComponent
}, {
    path: '/contacto',
    component: ContactoComponent
}, 
{
    path: '/validar',
    component: ValidacionQR
},
{
    path: '/registro',
    name: 'registro',
    component: RegistroComponent
}, 
{
    path: '/dashboard/:id?',
    name: 'dashboard',
    component: DashboardComponent,
    children: [{
        path: 'perfil',
        component: PerfilComponent
    }, {
        path: 'ofertaDisp',
        component: OfertaDispComponent
    }, {
        path: 'miFormacion',
        component: MiFormacionComponent
    }, {
        path: 'adminOfertas',
        component: AdminOfertaFomComponent
    }, {
        path: 'adminInstancias',
        component: AdminInstanciasComponent
    }, {
        path: 'adminGrupos',
        component: AdminGruposComponent
    }, {
        path: 'adminCargaMasiva',
        component: AdminCargaMasivaComponent
    }, {
        path: 'adminUsuarios',
        component: AdminUsuariosComponent
    }, {
        path: 'adminRegistros',
        component: AdminRegistrosComponent
    }, {
        path: 'adminReportes',
        component: AdminReportesComponent
    }]
}];

const router = new VueRouter({
    routes,
})

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
//})

